// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://dr-backend-4xmc.onrender.com/",
});

export default axiosInstance;

// export const weburl = "https://dr-backend-4xmc.onrender.com/";
export const weburl = "https://dr-backend-4xmc.onrender.com/";

export const shopurl = "https://admindrarrysmediclinic.spacedeco.in/";
export const mainurl = "https://drarrysmediclinic.spacedeco.in/";
export const fronturl = "https://drarrysmediclinic.spacedeco.in/";


export const keyLogin = process.env.REACT_APP_LOGIN_KEY;